import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/generos`;

export async function getGeneros() {
  const { data } = await axios.get(baseUrl);
  return data;
}

export async function getGeneroByCodigo(codigo) {
  if (!codigo) {
    return { success: false, data: null };
  }

  const { data } = await axios.get(`${baseUrl}/codigo/${codigo}`);
  return data;
}
